import { ReactNode } from 'react';
import { useLogger, useServices } from '@packages/shared/core/common/hooks';
import { useQuizStep } from '@packages/shared/core/quiz/hooks';
import { QuizScreenProps, SingleAnswerWithModalStepData } from '@packages/shared/core/quiz/entities';

type SingleAnswerWithModalStepProps = {
  id: string;
  renderQuizScreen: (stepData: QuizScreenProps) => ReactNode;
};

const SingleAnswerWithModalStep = ({ id, renderQuizScreen }: SingleAnswerWithModalStepProps) => {
  const logger = useLogger();
  const { analyticsService } = useServices();
  const { back, next, stepData, updateUserPreferences, totalSteps, stepOrder } = useQuizStep(id);

  if (!stepData) {
    // TODO add fallback
    logger.error(new TypeError(`Data for ${id} step not found`));
    return null;
  }

  const { dataKey, otherClickEvent, otherOpenEvent } = stepData as SingleAnswerWithModalStepData;

  const goBack = async () => back();

  const onChosen = async (text: string, key?: string) => {
    updateUserPreferences(dataKey, text.toLowerCase());
    await next(text, key);
  };

  const onCustomOpen = () => {
    analyticsService.trackQuizEvent(otherOpenEvent, {});
  };

  const onCustomChosen = (text: string, key: string) => {
    analyticsService.trackQuizEvent(otherClickEvent, { context: text });
    updateUserPreferences(dataKey, key.toLowerCase());
    next();
  };

  return (
    <>
      {renderQuizScreen({
        onChosen,
        onBack: goBack,
        onCustomChosen,
        onCustomOpen,
        totalSteps,
        stepOrder,
        ...(stepData as SingleAnswerWithModalStepData),
      })}
    </>
  );
};

export default SingleAnswerWithModalStep;
